import axios from "axios"
import { ROLES_ENDPOINT } from "../../../../../../utility/SourceAPI"

export const getRoles = async () => {
    const response = await axios.get(ROLES_ENDPOINT)
    return response.data
}

export const addRole = async (role) => {
    const response = await axios.post(ROLES_ENDPOINT, role)
    return response.data
}